import ImageSB from '@/components/atoms/image/ImageSB';
import LinkButton from '@/components/atoms/linkButton';
import { LinkButtonSBProps } from '@/components/atoms/linkButton/LinkSB';
import RichTextFieldSB, {
  RichTextFieldSBProps,
} from '@/components/atoms/richTextField/RichTextFieldSB';
import { Text } from '@/components/atoms/text';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import { SECTION_NAMES } from '@/components/integrations/trackingScripts/constants';

import { FeatureListStrapiProps } from '@/features/shared/FeatureListStrapi';
import { BlockWrapper } from '@/features/utils/BlockWrapper';

import { HomepageHero } from '.';

import IconGoogleLetter from '~/svg/IconGoogleLetter.svg';

export type HomepageHeroStrapiProps = {
  title: string;
  description: RichTextFieldSBProps;
  buttons: LinkButtonSBProps[];
  showMoneyBack?: boolean;
  featureList?: FeatureListStrapiProps;
};

export function HomepageHeroStrapi({
  block,
}: BlockComponentModel<HomepageHeroStrapiProps>) {
  const { title, description, buttons, showMoneyBack, featureList } = block;

  function Links() {
    return (
      <div className='flex flex-col gap-x-6 pb-4 md:flex-row md:justify-center'>
        {buttons.map((item, index) => (
          <div key={index}>
            {index === 0 ? (
              <div className='pb-5 md:pb-0'>
                <LinkButton
                  href={item.url}
                  variant='filled'
                  color='primary'
                  fullwidth={true}
                  classNames={{ root: 'md:w-[240px]' }}
                >
                  {item.text}
                </LinkButton>
              </div>
            ) : (
              <>
                <LinkButton
                  href={item.url}
                  variant='outlined'
                  color='secondary'
                  fullwidth={true}
                  leftSection={<IconGoogleLetter />}
                  classNames={{ root: 'md:w-[240px]' }}
                >
                  {item.text}
                </LinkButton>
              </>
            )}
          </div>
        ))}
      </div>
    );
  }

  const FormattedFeatures = () => (
    <>
      {featureList?.features.map((featureItem, index) => (
        <div key={index} className='flex items-center gap-3'>
          <ImageSB
            inner={{ classNames: { image: 'w-6' } }}
            block={{ ...featureList!.icon }}
          />
          <Text>{featureItem.name}</Text>
        </div>
      ))}
    </>
  );

  return (
    <BlockWrapper
      theme='light'
      classNames={{ root: 'pb-0 pt-8 md:!pb-0 md:!pt-8 m:!py-[60px]' }}
    >
      <div data-tracker-section={SECTION_NAMES.HERO}>
        <HomepageHero
          buttons={<Links />}
          title={title}
          description={
            <div className='text-neutral-N99 mb-8 md:mb-9 md:text-center'>
              <RichTextFieldSB
                block={description}
                classNames={{ link: { root: 'text-body-l sm:text-blog-body' } }}
              />
            </div>
          }
          featureList={featureList ? <FormattedFeatures /> : undefined}
          showMoneyBack={showMoneyBack}
        />
      </div>
    </BlockWrapper>
  );
}
